import { render, staticRenderFns } from "./XF.vue?vue&type=template&id=5b64812b&scoped=true&"
import script from "./XF.vue?vue&type=script&lang=js&"
export * from "./XF.vue?vue&type=script&lang=js&"
import style0 from "./XF.vue?vue&type=style&index=0&id=5b64812b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b64812b",
  null
  
)

export default component.exports